import { FormGroup } from '@angular/forms';
import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { addRemoveError } from '@shared/helpers/form.helper';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { isEqual } from 'lodash-es';
import { REQUIRED_STATUS } from '@shared/constants/shared.constants';
import { formPaths } from '@shared/constants/form-paths.const';
import {
    MyAllElemCollegioSindacaleEntity,
    MyAllElemRevisoriControlloContabileEntity,
} from '../../../../models/interfaces/revisione.interface';
import {
    getNormeSpaOrdinarioControl,
    getAmmControlloControl,
    normeSpaOrdinarioCkHelper,
    normeSpaOrdinarioRequiredHelper,
    checkCkNormeValue,
    checkCollegioSindacale,
} from './helpers/norme-spa-ordinario-form-validators.helper';

export const normeSpaOrdinarioOrganoControlloRules: FormGroupRules = {
    my_CkSpoCompStatoInOrgContr: (form: FormGroup) => {
        const my_CkSpoCompStatoInOrgContrControl = getNormeSpaOrdinarioControl(form, 'my_CkSpoCompStatoInOrgContr');
        const errors = my_CkSpoCompStatoInOrgContrControl.errors ? my_CkSpoCompStatoInOrgContrControl.errors : {};

        addRemoveError(checkCkNormeValue(form) && isNilOrEmpty(my_CkSpoCompStatoInOrgContrControl.value) && checkCollegioSindacale(form), errors, 'my_CkSpoCompStatoInOrgContr', {
            status: REQUIRED_STATUS,
        });

        my_CkSpoCompStatoInOrgContrControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_CkSpoCompOrgContrEletti: (form: FormGroup) => {
        const my_CkSpoCompOrgContrElettiControl = getNormeSpaOrdinarioControl(form, 'my_CkSpoCompOrgContrEletti');
        const errors = my_CkSpoCompOrgContrElettiControl.errors ? my_CkSpoCompOrgContrElettiControl.errors : {};

        addRemoveError(checkCkNormeValue(form) && isNilOrEmpty(my_CkSpoCompOrgContrElettiControl.value) && checkCollegioSindacale(form), errors, 'my_CkSpoCompOrgContrEletti', {
            status: REQUIRED_STATUS,
        });

        my_CkSpoCompOrgContrElettiControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_CkSpoRispettoLimite: (form: FormGroup) => {
        normeSpaOrdinarioCkHelper(
            form,
            'my_NormeSpaOrdinario.my_CkSpoRispettoLimite',
            'my_NormeSpaOrdinario.my_CkSpoCompOrgContrEletti',
            1,
            formPaths.ammControllo,
            checkCollegioSindacale(form)
        );
    },

    my_CkSpoSindaciRevisori: (form: FormGroup) => {
        const my_CkSpoSindaciRevisoriControl = getNormeSpaOrdinarioControl(form, 'my_CkSpoSindaciRevisori');
        const errors = my_CkSpoSindaciRevisoriControl.errors ? my_CkSpoSindaciRevisoriControl.errors : {};

        addRemoveError(checkCkNormeValue(form) && isNilOrEmpty(my_CkSpoSindaciRevisoriControl.value) && checkCollegioSindacale(form), errors, 'my_CkSpoSindaciRevisori', {
            status: REQUIRED_STATUS,
        });

        my_CkSpoSindaciRevisoriControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_CkSpoSindaciSceltiCoerenza: (form: FormGroup) => {
        normeSpaOrdinarioCkHelper(
            form,
            'my_NormeSpaOrdinario.my_CkSpoSindaciSceltiCoerenza',
            'my_NormeSpaOrdinario.my_CkSpoSindaciRevisori',
            0,
            formPaths.ammControllo,
            checkCollegioSindacale(form)
        );
    },

    my_CkSpoSindaciRelazionano: (form: FormGroup) => {
        const my_CkSpoSindaciRelazionanoControl = getNormeSpaOrdinarioControl(form, 'my_CkSpoSindaciRelazionano');
        const errors = my_CkSpoSindaciRelazionanoControl.errors ? my_CkSpoSindaciRelazionanoControl.errors : {};

        addRemoveError(checkCkNormeValue(form) && isNilOrEmpty(my_CkSpoSindaciRelazionanoControl.value) && checkCollegioSindacale(form), errors, 'my_CkSpoSindaciRelazionano', {
            status: REQUIRED_STATUS,
        });

        my_CkSpoSindaciRelazionanoControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_SpoNoteComposCollSind: (form: FormGroup) => {
        const my_SpoNoteComposCollSindControl = getNormeSpaOrdinarioControl(form, 'my_SpoNoteComposCollSind');
        const errors = my_SpoNoteComposCollSindControl.errors ? my_SpoNoteComposCollSindControl.errors : {};

        addRemoveError(checkCkNormeValue(form) && isNilOrEmpty(my_SpoNoteComposCollSindControl.value) && checkCollegioSindacale(form), errors, 'my_SpoNoteComposCollSind', {
            status: REQUIRED_STATUS,
        });

        my_SpoNoteComposCollSindControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_CkSpoAffidamContrCont: (form: FormGroup) => {
        const my_CkSpoAffidamContrContControl = getNormeSpaOrdinarioControl(form, 'my_CkSpoAffidamContrCont');
        const my_CkSpoAffidamContrCont: string = my_CkSpoAffidamContrContControl.value;
        const my_AllElemCollegioSindacale: MyAllElemCollegioSindacaleEntity[] = getAmmControlloControl(
            form,
            'my_AllCollegioSindacale.my_AllElemCollegioSindacale'
        ).value;
        const my_AllElemRevisoriControlloContabile: MyAllElemRevisoriControlloContabileEntity[] = getAmmControlloControl(
            form,
            'my_AllRevisoriControlloContabile.my_AllElemRevisoriControlloContabile'
        ).value;
        const my_CkSpoAssembNominOrgano: string = getNormeSpaOrdinarioControl(form, 'my_CkSpoAssembNominOrgano').value;
        const conteggioAllElemRevisori = my_AllElemRevisoriControlloContabile.length;
        const errors = my_CkSpoAffidamContrContControl.errors ? my_CkSpoAffidamContrContControl.errors : {};

        addRemoveError(checkCkNormeValue(form) && isNilOrEmpty(my_CkSpoAffidamContrCont), errors, 'my_CkSpoAffidamContrCont', {
            status: REQUIRED_STATUS,
        });

        addRemoveError(checkCkNormeValue(form) && !my_AllElemCollegioSindacale?.length && my_CkSpoAffidamContrCont === '5', errors, 'my_CkSpoAffidamContrCont', {
            status: 'Il Collegio Sindacale è obbligatorio se gli è stato affidato il Controllo contabile',
        });

        addRemoveError(checkCkNormeValue(form) && my_CkSpoAssembNominOrgano === '1' && my_CkSpoAffidamContrCont === '7', errors, 'my_CkSpoAffidamContrCont', {
            status: 'Incongruenza con la risposta 5',
        });

        addRemoveError(checkCkNormeValue(form) && conteggioAllElemRevisori <= 1 && my_CkSpoAffidamContrCont === '3', errors, 'my_CkSpoAffidamContrCont', {
            status: 'Inserire i revisori esterni',
        });

        addRemoveError(checkCkNormeValue(form) && conteggioAllElemRevisori !== 1 && my_CkSpoAffidamContrCont === '2', errors, 'my_CkSpoAffidamContrCont', {
            status: 'Inserire un revisore esterno',
        });

        addRemoveError(checkCkNormeValue(form) && my_CkSpoAffidamContrCont === '5' && !checkCollegioSindacale(form), errors, 'my_CkSpoAffidamContrCont', {
            status: 'Collegio sindacale non presente',
        });

        my_CkSpoAffidamContrContControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_SpoNoteComposContrContab: (form: FormGroup) => {
        normeSpaOrdinarioRequiredHelper(form, 'my_NormeSpaOrdinario.my_SpoNoteComposContrContab');
    },

    my_RagSocSocRevisione: (form: FormGroup) => {
        normeSpaOrdinarioCkHelper(form, 'my_SocRevisioneControlloContabile.my_RagSocSocRevisione', 'my_NormeSpaOrdinario.my_CkSpoAffidamContrCont', 1);
    },
};
